import React, { useEffect, useRef, useCallback, useMemo,useContext } from 'react';
import TreeView from 'devextreme-react/tree-view';
import {dashboardNavigation} from '../top-navigation/dashboard/navigation';
import { OrdersNavigation } from '../top-navigation/orders/navigation';
import { ShipmentsNavigation } from '../top-navigation/shipments/navigation';
import { ProductsNavigation } from '../top-navigation/products/navigation';
import { SettingsNavigation } from '../top-navigation/settings/navigation';
import { customersNavigation } from '../top-navigation/customers/navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './side-navigation-menu.scss';
import { NavbarContext } from '../../contexts/top-navigation';
import * as events from 'devextreme/events';
import orderNavApi from '../../api/order-nav';
import url from '../../api/base-url'
import {createStore} from "devextreme-aspnet-data-nojquery";
import Sessions from '../../sessions';
import 'whatwg-fetch';

export default function (props) {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady,
  } = props;

  const { isLarge } = useScreenSize();
  var menu = useContext(NavbarContext);
  var href  = window.location.href.split("/");

  const userId = Sessions.getSession("user")?.id;
  const menuID = menu.menuID ? menu.menuID : href[4];
  const auth = Sessions.getSession("user")?.accessToken;

  function getConfig(options) {  
      options.onBeforeSend = function(method, ajaxOptions) {  
          ajaxOptions.headers = {  
              "x-access-token": auth
          }  
      }  
      return options;  
  };

  useEffect(() => {
      (async()=>{
        await orderNavApi.updateBagde(userId,auth);
      })()
  }, [userId,auth]);

  const orderNavDataSource = createStore(getConfig({
    key: '_id', 
    loadUrl: `${url}/orders/navigation/${userId}`
    }));

  function normalizePath (menuID) {
    if(menuID === 'dashboard'){
        return  dashboardNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
                
            }
            return {...item, expanded: isLarge} 
        })
    }
    else if(menuID === 'orders'){
        return  OrdersNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
                
            }
            return {...item, expanded: isLarge} 
        })
    }
    else if(menuID === 'shipments'){
        return  ShipmentsNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
            }
            return {...item, expanded: isLarge} 
        })
    }
    else if(menuID === 'products'){
        return  ProductsNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
            }
            return {...item, expanded: isLarge} 
        });
    }
    else if(menuID === 'settings'){
        return  SettingsNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
            }
            return {...item, expanded: isLarge} 
        });
    }
    else if(menuID === 'customers'){
        return  customersNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
            }
            return {...item, expanded: isLarge} 
        });
    }
    else{
        return dashboardNavigation.map((item) => {
            if(item.path && !(/^\//.test(item.path))){ 
                item.path = `/${item.path}`;
            }
            return {...item, expanded: isLarge} 
        });
    }
  }

  const onItemClick = e => {
    treeViewRef.current.instance.selectItem(e.itemData.path);
    treeViewRef.current.instance.expandItem(e.itemData.path);
  }

  const items = useMemo(   
    () => normalizePath(menuID),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [menu.menuID]
  );

  const itemTemplate = (data, index) =>{

    return (
        <div className={'item-template'}>
            {data.icon?
                <i className={`dx-icon dx-icon-${data.icon}`}></i>
            :''
            }
            <span>{data.text}</span>
            {data.badge?
              <span className='dx-list-item-badge dx-badge'>{data.badge}</span>
             :''
            }
        </div>
    );
  }


  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef();
  const wrapperRef = useRef();
  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', e => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
      if(menuID==="orders"){
        orderNavApi.updateSelectedAndExpandedItembyId(userId,{'path':currentPath.toString()});
        const dataSource = treeView.getDataSource();
        dataSource.reload();
      }
    }

    if (compactMode) {
      treeView.collapseAll();
    }
    
  }, [currentPath, compactMode]);

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          dataSource={menuID==="orders"? orderNavDataSource:items}
          itemRender = {itemTemplate}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
